function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st1{stroke-width:4;stroke-miterlimit:10;}\n\t.st2{stroke-width:3;stroke-miterlimit:10;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.28,25.09c3.64,3.15,6.45,5.84,8.29,7.66,3.77,3.71,9.39,9.62,13,13.08,1.27,1.22,2.22,2.1,2.22,2.1,1.78,1.66,2.39,2.12,3.54,3.22,1.43,1.35,1.83,1.89,3.11,3.21,3.19,3.32,4.16,3.52,6.43,5.88a30.59,30.59,0,0,1,4.3,5.7ZM19.79,43.25A32.6,32.6,0,0,1,24,22.67a1,1,0,0,1,.23-.33,1.17,1.17,0,0,1,1.66,0l43,43h0a1.08,1.08,0,0,1,.18.24,1.17,1.17,0,0,1-.42,1.6,32.67,32.67,0,0,1-34-.58,33.32,33.32,0,0,1-5.6-4.49,32.49,32.49,0,0,1-9.28-18.9Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M45.67,69.12l8.08,16.7a1.16,1.16,0,0,1-.55,1.56,1.11,1.11,0,0,1-.5.12H22a1.17,1.17,0,0,1-1.17-1.17,1.14,1.14,0,0,1,.17-.61L32.3,63.77a1.18,1.18,0,0,1,1.58-.51.91.91,0,0,1,.16.11h0a30,30,0,0,0,7.85,4.23c.45.16,1,.32,1.48.48s1,.3,1.52.42a1.14,1.14,0,0,1,.78.63Zm5.16,16-7-14.54-1.09-.3c-.51-.16-1-.33-1.61-.54a32.54,32.54,0,0,1-4.4-2A32.94,32.94,0,0,1,33.76,66L23.9,85.16Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M54.5,36.31A1.17,1.17,0,0,1,56.16,38L48,46.14a1.17,1.17,0,0,1-1.66,0,1.19,1.19,0,0,1,0-1.66Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.7,33.83a1.79,1.79,0,0,0-2.52,0,1.78,1.78,0,0,0,2.52,2.52,1.79,1.79,0,0,0,0-2.52ZM57.44,31a4.13,4.13,0,0,1,2.92,7,4.12,4.12,0,1,1-2.92-7Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M54.5,36.3c0.5-0.5,1.2-0.5,1.7,0s0.5,1.2,0,1.7L48,46.1c-0.5,0.5-1.2,0.5-1.7,0l0,0c-0.4-0.5-0.4-1.2,0-1.7 L54.5,36.3z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "st2",
  d: "M61,27.9c-0.6,0.1-1.3-0.2-1.4-0.9c-0.1-0.6,0.2-1.3,0.9-1.4c0.9-0.2,1.9-0.2,2.9,0c2,0.5,3.6,2,4.1,4.1 c0.2,0.9,0.2,1.9,0,2.9c-0.1,0.6-0.8,1-1.4,0.9s-1-0.8-0.9-1.4c0.1-0.6,0.1-1.2,0-1.8c-0.3-1.2-1.2-2.1-2.3-2.3 C62.2,27.7,61.6,27.7,61,27.9z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "st2",
  d: "M58.9,21.3c-0.6,0.1-1.3-0.2-1.4-0.9c-0.1-0.6,0.2-1.3,0.9-1.4l0,0c2.1-0.5,4.4-0.5,6.5,0 c4.5,1,8.1,4.6,9.1,9.1c0.5,2.2,0.5,4.4-0.1,6.5c-0.1,0.6-0.8,1-1.4,0.9s-1-0.8-0.9-1.4c0.4-1.8,0.5-3.7,0.1-5.5 c-0.8-3.7-3.7-6.5-7.4-7.4C62.6,20.9,60.7,20.9,58.9,21.3L58.9,21.3z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "st2",
  d: "M60.5,15.3c-0.6,0.1-1.3-0.3-1.4-0.9C59,13.8,59.4,13.1,60,13c2.8-0.7,5.6-0.7,8.4-0.1 c5.8,1.4,10.3,5.9,11.6,11.7c0.6,2.8,0.6,5.6-0.1,8.4c-0.1,0.6-0.7,1.1-1.3,1s-1.1-0.7-1-1.3c0-0.1,0-0.1,0-0.2 c0.6-2.4,0.6-4.9,0.1-7.3c-1.1-4.9-5-8.8-9.9-9.9C65.4,14.7,62.9,14.7,60.5,15.3L60.5,15.3z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  x: 31.82,
  y: 60.62,
  width: 14.83,
  height: 26.33
});

var _ref12 =
/*#__PURE__*/
React.createElement("rect", {
  x: 23.48,
  y: 81.52,
  width: 27.35,
  height: 4.74
});

var _ref13 =
/*#__PURE__*/
React.createElement("rect", {
  x: 25.48,
  y: 78.42,
  width: 7.76,
  height: 4.1
});

var _ref14 =
/*#__PURE__*/
React.createElement("rect", {
  x: 25.81,
  y: 77.64,
  width: 10.53,
  height: 2.44
});

var _ref15 =
/*#__PURE__*/
React.createElement("rect", {
  x: 30.02,
  y: 68.88,
  width: 1.88,
  height: 13.19
});

var _ref16 =
/*#__PURE__*/
React.createElement("rect", {
  x: 28.25,
  y: 74.09,
  width: 5.32,
  height: 6.54
});

var _ref17 =
/*#__PURE__*/
React.createElement("rect", {
  x: 29.03,
  y: 72.87,
  width: 1.77,
  height: 2.11
});

var _ref18 =
/*#__PURE__*/
React.createElement("rect", {
  x: 26.92,
  y: 76.42,
  width: 2.33,
  height: 2.33
});

var _ref19 =
/*#__PURE__*/
React.createElement("rect", {
  x: 45.54,
  y: 76.42,
  width: 2.77,
  height: 6.98
});

var _ref20 =
/*#__PURE__*/
React.createElement("rect", {
  x: 44.66,
  y: 80.19,
  width: 6.21,
  height: 4.43
});

var _ref21 =
/*#__PURE__*/
React.createElement("rect", {
  x: 46.93,
  y: 79.91,
  width: 2.38,
  height: 2.16
}, React.createElement("circle", {
  cx: 57.57,
  cy: 35.24,
  r: 2.05
}));

var SvgSatelliteIcon = function SvgSatelliteIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    "aria-hidden": "true",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, " -->\n", _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSatelliteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/satellite-icon.4182af2e.svg";
export { ForwardRef as ReactComponent };